import { render, staticRenderFns } from "./DisplayBuilderOptions.vue?vue&type=template&id=0ae5c51c&scoped=true"
import script from "./DisplayBuilderOptions.vue?vue&type=script&lang=js"
export * from "./DisplayBuilderOptions.vue?vue&type=script&lang=js"
import style0 from "./DisplayBuilderOptions.vue?vue&type=style&index=0&id=0ae5c51c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae5c51c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae5c51c')) {
      api.createRecord('0ae5c51c', component.options)
    } else {
      api.reload('0ae5c51c', component.options)
    }
    module.hot.accept("./DisplayBuilderOptions.vue?vue&type=template&id=0ae5c51c&scoped=true", function () {
      api.rerender('0ae5c51c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/display-builder/DisplayBuilderOptions.vue"
export default component.exports